import styled from 'styled-components';
import HappyGoTribeNewIconSvg from './happyGoTribeNew.svg';

const HappyGoTribeNewIcon = styled(
  HappyGoTribeNewIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '4.9rem'};
  height: ${props => props.height || '1.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default HappyGoTribeNewIcon;
